import React, { useEffect, useState } from 'react'

import Header from '../../../Components/Header'
import Seo from '../../../Components/SeoComponent/Seo'
import { Button, InputWithLabel } from '../../../Components/Tags/Tags';
import Loader from '../../../Loader';
import { fetchProfile } from '../../../Services/ApiTestService/aadharTestService';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { Link } from 'react-router-dom';
import { FaCopy } from 'react-icons/fa';
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { verifyKybRcValiationService } from '../../../Services/ApiTestService/apiTestService';
import {RcVerify} from "../data2";
import { useService } from '../../../context/ServiceContext';

const VerifyRc = () => {
    const [rcNumber, setRcNumber] = useState('');
    const [profileData, setProfileData] = useState('');
    const [rcData, setRcData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const { serviceName } = useService();
    const handleSubmit = async () => {

        if (rcNumber === "") {
            showErrorToast('Registration number is required.');
            return;
        }
        try {
            const payload = {
                api_id: profileData?.user_id,
                api_key: profileData?.api_key,
                token_id: profileData?.token_id,
                reg_no: rcNumber
            }
            setIsLoading(true);
            let response = await verifyKybRcValiationService(payload);
            setIsLoading(false)
            if (response.status.code === 200) {
                setRcData(response.data || null);
                setRcNumber('')
                showSuccessToast(response.message || response.status.message || "Rc Validation completed successfully");
            } else {
                setRcData(null);
                showErrorToast(response.message || response.status.message || response.data.message || response.errors || "An unexcepted error occurs while fetching details")
            }

        } catch (error) {
            setIsLoading(false);
            showErrorToast('Something went wrong while rc validation', error);
        }



    };
    function handleCopyText(data) {
        window.navigator.clipboard.writeText(JSON.stringify(data));
        showSuccessToast('Copied successfully')
    }
    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                setIsLoading(true);
                const response = await fetchProfile();
                setProfileData(response.data);
            } catch (error) {
                console.error("Error fetching profile data:", error);
                showErrorToast("Failed to fetch profile data.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchProfileData();
    }, []);
    return (
        <>
            {isLoading && <Loader />}
            <Header heading={serviceName} />
            <Seo title={serviceName} />

            <div>

                <div className="col-span-2 md:col-span-6 flex justify-end">
                    <Link
                        to="/TestMaster"
                        className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
                    >
                        <span>Go Back</span>
                        <IoArrowBackCircleOutline size={24} />
                    </Link>
                </div>
                <div className='flex items-center gap-2 py-2 bg-gray-100 shadow-sm'>

                    <div>
                        <InputWithLabel
                            label={"Registration Number"}
                            placeholder={"Enter Registration Number "}
                            required={true}
                            value={rcNumber}
                            onChange={(e) => setRcNumber(e.target.value)}
                        />

                    </div>



                    <div className='mt-4'>
                        <Button type={'button'} text={"Verify"} onClick={handleSubmit} />
                    </div>

                </div>

                <div>
                    {rcData !== null ?
                        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div><RCCard rcData={rcData} /></div>
                            <div>
                                <h3 className="bg-green-200 text-xl font-bold my-2 rounded p-2">Api Response </h3>
                                <pre className="bg-black relative text-green-500 p-4 rounded text-sm overflow-auto max-h-[600px]">
                                    <FaCopy className="absolute top-2 cursor-pointer right-2  bg-white p-1 rounded-md font-bold text-2xl" onClick={() => handleCopyText(rcData)} />
                                    {JSON.stringify(rcData, null, 2)}
                                </pre>
                            </div>
                        </div>

                        : ""}
                </div>

                <RcInstructions />
            </div>
        </>
    );
};


const RcInstructions = () => {
    return (
        <div className="max-w-5xl mx-auto p-5 bg-white shadow-lg rounded-lg border border-gray-200">
            <h1 className="text-xl font-semibold mb-3 text-red-600 border-b pb-2"> RC Validation   Instructions</h1>
            <ol className="list-decimal pl-5 space-y-3 text-gray-700 text-sm">


                <li>
                    <strong>Important:</strong>
                    <ul className="list-disc pl-5 mt-1 text-gray-600">
                        <li>Enter Registration Number.</li>
                        <li>Make sure registration number should be correct . </li>
                        <li>Don't close or reload page until process is completed.</li>
                    </ul>
                </li>
                <li>
                    <strong>Important:</strong>
                    <ul className="list-disc pl-5 mt-1 text-gray-600">
                        <li>Registration number should be correct </li>
                        <li>Don't use any space in registration number</li>
                        <li>No spaces or symbols </li>
                    </ul>
                </li>
                <li>
                    <strong>Having Issues?</strong>
                    <ul className="list-disc pl-5 mt-1 text-gray-600">
                        <li>Double-check Register Number.</li>

                    </ul>
                </li>

            </ol>
        </div>
    );
};








export const RCCard = ({ rcData }) => {
  // Fallback helper
  const safe = (value) => (value ? value : "N/A");

  if (!rcData) {
    return (
      <div className="w-[370px] border shadow-lg rounded-lg bg-gray-50 text-center p-6 text-gray-600">
        <p>No RC data available.</p>
      </div>
    );
  }

  return (
    <div className="w-[370px] sm:w-full border shadow-2xl rounded-lg overflow-hidden font-sans bg-white">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-700 via-sky-400 to-blue-900 p-3 flex justify-between items-center">
        <div className="text-white font-semibold text-lg">Vehicle RC Details</div>
        <img
          src="https://cdn-icons-png.flaticon.com/512/1995/1995525.png"
          alt="RC Logo"
          className="w-8 h-8"
        />
      </div>

      {/* Body */}
      <div className="p-4 text-sm space-y-2 text-gray-700">
        <div><strong>Registration No:</strong> {safe(rcData?.reg_no)}</div>
        <div><strong>Owner Name:</strong> {safe(rcData?.owner_name)}</div>
        <div><strong>Father's Name:</strong> {safe(rcData?.owner_father_name)}</div>
        <div><strong>Vehicle Class:</strong> {safe(rcData?.class)}</div>
        <div><strong>Manufacturer:</strong> {safe(rcData?.vehicle_manufacturer_name)}</div>
        <div><strong>Model:</strong> {safe(rcData?.model)}</div>
        <div><strong>Fuel Type:</strong> {safe(rcData?.type)}</div>
        <div><strong>Chassis No:</strong> {safe(rcData?.chassis)}</div>
        <div><strong>Engine No:</strong> {safe(rcData?.engine)}</div>
        <div><strong>Colour:</strong> {safe(rcData?.vehicle_colour)}</div>
        <div><strong>Body Type:</strong> {safe(rcData?.body_type)}</div>
        <div><strong>Owner Count:</strong> {safe(rcData?.owner_count)}</div>
        <div><strong>Manufacturing Year:</strong> {safe(rcData?.vehicle_manufacturing_month_year)}</div>
        <div><strong>Registration Date:</strong> {safe(rcData?.reg_date)}</div>
        <div><strong>RC Expiry Date:</strong> {safe(rcData?.rc_expiry_date)}</div>
        <div><strong>Insurance Upto:</strong> {safe(rcData?.vehicle_insurance_upto)}</div>
        <div><strong>Insurance Company:</strong> {safe(rcData?.vehicle_insurance_company_name)}</div>
        <div><strong>Permit Type:</strong> {safe(rcData?.permit_type)}</div>
        <div><strong>Permit Valid Upto:</strong> {safe(rcData?.permit_valid_upto)}</div>
        <div><strong>Tax Paid Upto:</strong> {safe(rcData?.vehicle_tax_upto)}</div>
        <div><strong>PUCC Upto:</strong> {safe(rcData?.pucc_upto)}</div>
        <div><strong>RC Status:</strong> {safe(rcData?.status)}</div>

        {/* Address */}
        <div className="border-t pt-2 mt-3">
          <strong>Registered Address:</strong>
          <div className="text-gray-600">
            {safe(rcData?.present_address)}
          </div>
        </div>

        {/* Optional Extra Details */}
        <div className="border-t pt-2 mt-3">
          <strong>RTO:</strong> {safe(rcData?.reg_authority)}<br />
          <strong>RTO Code:</strong> {safe(rcData?.rto_code)}<br />
          <strong>Vehicle Category:</strong> {safe(rcData?.vehicle_category)}<br />
          <strong>GVW (kg):</strong> {safe(rcData?.gross_vehicle_weight)}<br />
          <strong>Unladen Weight (kg):</strong> {safe(rcData?.unladen_weight)}<br />
          <strong>Seat Capacity:</strong> {safe(rcData?.vehicle_seat_capacity)}<br />
          <strong>Wheelbase (mm):</strong> {safe(rcData?.wheelbase)}<br />
        </div>
      </div>

      {/* Footer */}
      <div className="bg-gray-100 text-center py-2 text-xs text-gray-500">
        Status as on: {safe(rcData?.status_as_on)}
      </div>
    </div>
  );
};




export default VerifyRc
